export const spinner = {
    sizes: {
        xs: '10px',
        sm: '14px',
        md: '18px',
        lg: '20px',
        xl: '28px',
        xxl: '60px',
    },
};
//# sourceMappingURL=spinner.js.map